type DroppedFile = {
  file: File;
  type: string;
};
export async function getFilesAsync(dataTransfer: DataTransfer) {
  const files: DroppedFile[] = [];

  const len = dataTransfer.items.length;

  const promises: Promise<any>[] = [];
  for (let i = 0; i < len; i++) {
    const item = dataTransfer.items[i];
    if (item.kind === "file") {
      if (typeof item.webkitGetAsEntry === "function") {
        const entry = item.webkitGetAsEntry();
        if (entry) {
          promises.push(
            readEntryContentAsync(entry).then((entryContent) => {
              files.push(...entryContent);
            })
          );
        }
        continue;
      }

      const file = item.getAsFile();
      if (file) {
        files.push({ file, type: item.type });
      }
    }
  }

  await Promise.all(promises);

  return files;
}
// Returns a promise with all the files of the directory hierarchy
function readEntryContentAsync(entry: FileSystemEntry) {
  return new Promise<DroppedFile[]>((resolve, reject) => {
    let reading = 0;
    const contents: DroppedFile[] = [];

    readEntry(entry);

    function readEntry(entry: FileSystemEntry) {
      if (isFile(entry)) {
        reading++;
        entry.file((file) => {
          reading--;
          contents.push({ file, type: file.type });

          if (reading === 0) {
            resolve(contents);
          }
        });
      } else if (isDirectory(entry)) {
        readReaderContent(entry.createReader());
      }
    }

    function readReaderContent(reader: FileSystemDirectoryReader) {
      reading++;

      reader.readEntries(function (entries) {
        reading--;
        for (const entry of entries) {
          readEntry(entry);
        }

        if (reading === 0) {
          resolve(contents);
        }
      });
    }
  });
}
// for TypeScript typing (type guard function)
// https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
function isDirectory(
  entry: FileSystemEntry
): entry is FileSystemDirectoryEntry {
  return entry.isDirectory;
}
function isFile(entry: FileSystemEntry): entry is FileSystemFileEntry {
  return entry.isFile;
}
